import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../axios";
import "./SimilarAdsPage.css";
import AdCard from "./AdCard";

const SimilarAdsPage = () => {
  const { id } = useParams();  

  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        const res = await axios.get(`/api/ads/${id}/similar/?limit=20`);
        setAds(res.data || []);
      } catch (e) {
        console.error("Σφάλμα φόρτωσης παρόμοιων:", e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  if (loading) {
    return <div className="similar-page">🔄 Φόρτωση...</div>;
  }

  return (
    <div className="similar-page">
      <h2 className="similar-title">Παρόμοιες αγγελίες</h2>

      {ads.length === 0 ? (
        <div className="similar-empty">Δεν βρέθηκαν αγγελίες</div>
      ) : (
        <div className="ads-grid">
          {ads.map((ad) => (
            <AdCard key={ad.id} ad={ad} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SimilarAdsPage;